import { render, staticRenderFns } from "./MajorManage.vue?vue&type=template&id=421a958f&scoped=true"
import script from "./MajorManage.vue?vue&type=script&lang=js"
export * from "./MajorManage.vue?vue&type=script&lang=js"
import style0 from "./MajorManage.vue?vue&type=style&index=0&id=421a958f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421a958f",
  null
  
)

export default component.exports